// Direct import (webpack bundles at build). File is regenerated by /app/scripts/generate_articles.py.
import articles from './generatedArticles.json';
export function getGeneratedArticles() {
  return Array.isArray(articles) ? articles : [];
}
